import Tabs from "./tabs";

import mapDealers from "./mapDealers";
import googleMapInit from "./googleMap";
import dealersTabs from './dealers'
import StickyBlock from "./stickyBlock";
import scrollTop from "../utils/scrollTop";

const initContacts = () => {
    const stickyContactsArchive = new StickyBlock('.js-sticky-contacts-archive', '.js-sticky-contacts-archive-wrapper', 1250);
    const contactTabs = new Tabs('.js-contact-tab-link', (link) => {
        stickyContactsArchive.destroy();
        stickyContactsArchive.init();
        mapDealers(link);
        scrollTop();
    });

    function mainMap() {
        const mapCont = $('.js-map');
        if (mapCont) {
            const lat = mapCont.data('lat'),
                lng = mapCont.data('lng'),
                zoom = mapCont.data('zoom');

            let options = {
                loc: [
                    {
                        lat: lat,
                        lng: lng,
                    },
                ],
                zoom: zoom
            }

            googleMapInit(options, '.js-map #map');
        }
    }


    const addContactsHashToUrl = ($elem) => {
        if ( location.hash !== ('#' + $elem.data('hash') ) ) {
            location.hash = '#' + $elem.data('hash');
        }
    }


    $('.js-contact-tab-link, .js-sales-tab-link, .js-dealer-city').on('click', function() {
        const $this = $(this);

        addContactsHashToUrl($this);
    });

    function goToTabFromUrl() {
        const hash = location.hash;

        if (hash && $(document.body).hasClass('page-template-contacts') ) {
            const $elem = $('[data-hash=' + hash.replace('#', '') + ']');

            if ($elem.hasClass('js-sales-tab-link') || $elem.hasClass('js-dealer-city') ) {
                activateParentTab( $elem );
            }
            $elem.trigger('click');
        }
    }

    function activateParentTab( $elem ) {
        const dataParentTabAttr = $elem.closest('.js-tab').attr('id').replace('tab-', '');

        $('[data-slug=' + dataParentTabAttr + ']').trigger("click");
    }

    mainMap();
    stickyContactsArchive.init();
    contactTabs.init();
    dealersTabs();
    goToTabFromUrl();


}

export default initContacts;